// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zqh9","input":"styles_input__2AjxG"};